import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../style/normalize.css"
import "../style/all.scss"

const AboutPage = ({ data }, location) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout title={siteTitle}>
      <SEO title="About" keywords={[`blog`, `gatsby`, `javascript`, `react`]} />

      <article className="post-content page-template no-image">
        <div className="post-content-body">
          <h2 id="intro">
            Austin seeks interesting places, people, feelings.
          </h2>
          <figure className="kg-card kg-image-card kg-width-full">
            <Img
              fluid={data.sdMount.childImageSharp.fluid}
              className="kg-image"
            />
          </figure>
          <p>
            Currently in NYC, reinventing             <a href="https://www.peek.us">
              the way peple shop for real estate
            </a>{" "}
          </p>
          <p>
            travels often, camera always in tow.
          </p>
        </div>
      </article>
    </Layout>
  )
}

const indexQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    sdMount: file(
      relativePath: { eq: "DSC03637.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default props => (
  <StaticQuery
    query={indexQuery}
    render={data => (
      <AboutPage location={props.location} data={data} {...props} />
    )}
  />
)
